import { debounce } from 'lodash';
export class AnchorNav {
    private anchorNavElement: HTMLElement;
    private anchorNavSelect: HTMLSelectElement;
    private anchorNavLinks: HTMLElement[];
    constructor(anchorNav: HTMLElement) {
        this.anchorNavElement = anchorNav;
        this.anchorNavLinks = Array.from(anchorNav.querySelectorAll('[data-anchor-nav-link]'));
        this.anchorNavSelect = anchorNav.querySelector("[data-anchornav-select]");
        this.anchorNavSelect.addEventListener('change', (e) => {
            window.location.hash = this.anchorNavSelect.value
        });
        document.documentElement.classList.add('has-anchor-nav');
        document.documentElement.style.setProperty('--anchor-nav-height', `${this.anchorNavElement.offsetHeight}px`);
        window.addEventListener('resize', debounce(this.resizeHandler.bind(this), 50));
        this.activateAnchorNavLinks();
    }

    activateAnchorNavLinks = () => {
        this.anchorNavLinks.forEach(link => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                //Get target position if it's above or below current visible area.
                const target = document.querySelector(link.getAttribute('href'));
                const rect = target.getBoundingClientRect();
                const isAbove = rect.bottom <= 0;
                window.location.hash = "";//reset the hash
                //update data-nav-expanded so css scroll-margin-top works properly
                if (isAbove) {
                    document.documentElement.setAttribute('data-nav-expanded', 'true')
                }
                else {
                    document.documentElement.setAttribute('data-nav-expanded', 'false')
                }
                window.location.hash = link.getAttribute('href');
            });
        });
    }

    resizeHandler = () => {
        document.documentElement.style.setProperty('--anchor-nav-height', `${this.anchorNavElement.offsetHeight}px`);
    }
}